// AUTH REDUCER
export const SIGN_OUT = "SIGN_OUT";
export const SIGN_IN = "SIGN_IN";
export const TOGGLE_LOADING = "TOGGLE_LOADING";
export const CHANGE_ROUTE = "CHANGE_ROUTE";
export const CHANGE_COMPANY = "CHANGE_COMPANY";
export const ADD_COMPANY_LIST = "ADD_COMPANY_LIST";
export const ADD_MENU_LIST = "ADD_MENU_LIST";
export const ADD_USER_BRANCH_LIST = "ADD_USER_BRANCH_LIST";
export const SET_COLLAPSABLE = "SET_COLLAPSABLE";
export const SET_DAY_SHIFT_TERMINAL_MODAL = "SET_DAY_SHIFT_TERMINAL_MODAL";
export const CHANGE_DATE_FROM = "CHANGE_DATE_FROM";
export const CHANGE_DATE_TO = "CHANGE_DATE_TO";
export const CHANGE_BRANCH = "CHANGE_BRANCH";
// BASIC FORM REDUCER
export const SET_INITIAL_STATE = "SET_INITIAL_STATE";
export const SET_TABLE_DATA = "SET_TABLE_DATA";
export const SET_FORM_FIELD_VALUE = "SET_FORM_FIELD_VALUE";
export const SET_SEARCH_FIELD_VALUE = "SET_SEARCH_FIELD_VALUE";
export const RESET_STATE = "RESET_STATE";
export const SET_SUPPORTING_TABLE = "SET_SUPPORTING_TABLE";
export const RESET_FORM_FIELD = "RESET_FORM_FIELD";
export const UPDATE_FORM_FIELD = "UPDATE_FORM_FIELD";
export const TOGGLE_FORM_LOADING = "TOGGLE_FORM_LOADING";
export const TOGGLE_TABLE_LOADING = "TOGGLE_TABLE_LOADING";
export const SET_SUPP_TABLES_TABLE = "SET_SUPP_TABLES_TABLE";

// POINT OF SALE REDUCER
export const SET_SALE_RETURN_STATE = "SET_SALE_RETURN_STATE";
export const SALE_RETURN_MODE = "SALE_RETURN_MODE";
export const CLOSE_SALE_RETURN_MODE = "CLOSE_SALE_RETURN_MODE";
export const OPEN_ORDER_MODE = "OPEN_ORDER_MODE";
export const OPEN_CUSTOMER_TABLE = "OPEN_CUSTOMER_TABLE";
export const OPEN_CUSTOMER = "OPEN_CUSTOMER";
export const OPEN_PUNCH = "OPEN_PUNCH";
export const CLOSE_DRAWERS = "CLOSE_DRAWERS";
export const OPEN_PRODUCT = "OPEN_PRODUCT";
export const SET_POS_STATE = "SET_POS_STATE";
export const SET_POS_STATE_RESERVATION = "SET_POS_STATE_RESERVATION";
export const SET_CUSTOMER_DETAIL = "SET_CUSTOMER_DETAIL";
export const SET_RESERVATION_DETAIL = "SET_RESERVATION_DETAIL";
export const SET_CUSTOMER_SUPPORTING_TABLE = "SET_CUSTOMER_SUPPORTING_TABLE";
export const SET_RESERVATION_SUPPORTING_TABLE =
  "SET_RESERVATION_SUPPORTING_TABLE";
export const SET_CUSTOMER_SUPPORTING_SINGLE_TABLE =
  "SET_CUSTOMER_SUPPORTING_SINGLE_TABLE";
export const ADD_TO_CART = "ADD_TO_CART";
export const RESET_DEFAULT_POS_STATE = "RESET_DEFAULT_POS_STATE";
export const SET_RECALL_ORDER = "SET_RECALL_ORDER";
export const UPDATE_PRODUCT_CART = "UPDATE_PRODUCT_CART";
export const SET_REPORTS_DATA = "SET_REPORTS_DATA";
export const SET_REPORTS_LOADING = "SET_REPORTS_LOADING";
export const SET_BRANCHES_LOADING = "SET_BRANCHES_LOADING";
export const SET_BRANCHES = "SET_BRANCHES";
export const SET_SUPP_TABLE_REPORT = "SET_SUPP_TABLE_REPORT";
export const SET_REPORT_VIEW_LOADING = "SET_REPORT_VIEW_LOADING";
export const SET_REPORT_VIEW_DATA = "SET_REPORT_VIEW_DATA";
export const SET_REPORT_VIEW_DATA_SUPPORTING_TABLE =
  "SET_REPORT_VIEW_DATA_SUPPORTING_TABLE";
export const SET_CART_RANDOM_ID_STATE = "SET_CART_RANDOM_ID_STATE";
export const TOGGLE_ORDER_DETAIL = "TOGGLE_ORDER_DETAIL";
export const SET_GST = "SET_GST";
export const SET_GST_AMOUNT = "SET_GST_AMOUNT";
export const SET_ORDER_MODE_LIST = "SET_ORDER_MODE_LIST";
export const SET_ORDER_SOURCE_LIST = "SET_ORDER_SOURCE_LIST";
export const SET_HOLD_ORDER = "SET_HOLD_ORDER";
export const SET_ORDER_SOURCE = "SET_ORDER_SOURCE";
export const SET_PRINTING_TEMPLATE = "SET_PRINTING_TEMPLATE";

// actionTypes.js
export const SET_USER_INTERACT_ON = "SET_USER_INTERACT_ON";
export const SET_USER_INTERACT_OFF = "SET_USER_INTERACT_OFF";
